function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import regeneratorRuntime from "regenerator-runtime";
import { computed, defineComponent, ref, reactive, watch, toRefs, onUnmounted } from "vue";
import { definePropType } from "@types-vue/props";
import _ from "lodash";
import elDragDialog from "@com/directive/el-drag-dialog";
import ImagePreviewPopover from "@com/components/preview-popover/image-preview-popover.vue";
import AudioManager from "@com/components/resource-manager/audio-manage.vue";
import SearchFilter from "@pt/components/search-filter/index.vue";
import PictureManage from "./picture-manage.vue";
import ModelManage from "./model-manage.vue";
import VideoManage from "./video-manage.vue";
import XlzManage from "./xlz-manage.vue";
import { tabTypeList, getToolKey, getTypeKey } from "./resource-manage";
import { tabNameList } from "./config";
import { assetsList, getAssetRetryTranscode } from "@pt/api/assets";
import { getMainTagAssetList, getCommonComponentList, getAssetTag } from "@ps/api/common/asset";
import { getTransCodeAddPendingId, getTranscodeProgress, updateProgress } from "@pt/utils/assets-transcode";
export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        /* 查询 具体规则见config.t文件 */ model: {
            type: definePropType(Object),
            default: function() {
                return {
                    type: "image"
                };
            }
        },
        // 默认展示的tab页
        defaultTab: {
            type: String,
            default: "commonImage"
        },
        /** tab的名称规则 */ /**
     * common + 类型： 公共数据；asset + 类型：我的资产库；
     * 图片：['commonImage', 'assetImage']
     * 音效：['commonAudio', 'assetAudio']
     * 背景音乐: ['bgmVideo','assetAudio']
     * 视频: ['assetVideo','commonVideo']
     */ tabKeyList: {
            type: definePropType(Array),
            default: function() {
                return [
                    "commonImage",
                    "assetImage"
                ];
            }
        },
        /** 窗口距离右侧距离 */ left: {
            type: String,
            default: "0px"
        },
        /** 窗口距离顶部距离 */ top: {
            type: String,
            default: "15vh"
        }
    },
    components: {
        SearchFilter: SearchFilter,
        PictureManage: PictureManage,
        // @ts-ignore
        ImagePreviewPopover: ImagePreviewPopover,
        AudioManager: AudioManager,
        VideoManage: VideoManage,
        XlzManage: XlzManage,
        ModelManage: ModelManage
    },
    directives: {
        elDragDialog: elDragDialog
    },
    setup: function setup(props, param1) {
        var emit = param1.emit;
        // @ts-ignore
        var _$ref1 = toRefs(props), visible = _$ref1.visible, defaultTab = _$ref1.defaultTab, model = _$ref1.model, tabKeyList = _$ref1.tabKeyList, left = _$ref1.left, top = _$ref1.top;
        var searchFilterRef = ref();
        var listLoading = ref(false);
        var listData = ref([]);
        var tagList = ref([]);
        var listTotal = ref(0);
        var currentTab = reactive({
            key: defaultTab.value,
            tagId: null,
            groupId: null,
            searchValue: "",
            search: "",
            componentsTitle: "",
            type: null,
            listTagId: null
        });
        var searchOptions = ref([]);
        var timer = null;
        var tabList = computed(function() {
            var arr = [];
            if (tabTypeList.hasOwnProperty(model.value.type)) {
                // @ts-ignore
                for(var key in tabTypeList[model.value.type]){
                    if (tabKeyList.value.indexOf(key) !== -1) {
                        // @ts-ignore
                        arr.push(tabTypeList[model.value.type][key]);
                    }
                }
            }
            return arr;
        });
        var clearCurretTab = function() {
            listData.value = [];
            currentTab.groupId = null;
            currentTab.tagId = null;
            currentTab.listTagId = null;
            currentTab.searchValue = "";
            currentTab.search = "";
            currentTab.componentsTitle = "";
            currentTab.type = null;
        };
        var handleClose = function() {
            clearCurretTab();
            timer && clearTimeout(timer);
            searchOptions.value = [];
            emit("update:visible", false);
        };
        var initListData = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var typeMapping, res, transCodeId;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            // 清空定时器
                            timer && clearTimeout(timer);
                            listLoading.value = true;
                            typeMapping = {
                                bgm: "audio",
                                model: "3d_model"
                            };
                            _ctx.next = 6;
                            return assetsList({
                                page: 1,
                                page_size: 50,
                                types: [
                                    typeMapping[model.value.type] || model.value.type
                                ],
                                formats: model.value.type === "model" ? undefined : model.value.formats,
                                size_max: model.value.size_max,
                                size_min: model.value.size_min,
                                skeleton_type: model.value.skeleton_type,
                                order: model.value.order
                            });
                        case 6:
                            res = _ctx.sent;
                            listData.value = _.get(res, "data.data.list") || [];
                            listTotal.value = _.get(res, "data.data.total") || 0;
                            listData.value.map(function(item) {
                                Object.assign(item, {
                                    icon_url: item.cover_url,
                                    file_url: item.full_url,
                                    thumb_url: item.cover_url
                                });
                                return item;
                            });
                            transCodeId = getTransCodeAddPendingId(listData.value).transCodeId;
                            // 转码进度查询
                            if (transCodeId.length) {
                                getAssetProgress(transCodeId);
                            }
                            listLoading.value = false;
                            _ctx.next = 19;
                            break;
                        case 15:
                            _ctx.prev = 15;
                            _ctx.t0 = _ctx["catch"](0);
                            listLoading.value = false;
                            console.log(_ctx.t0);
                        case 19:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        15
                    ]
                ]);
            }));
            return function initListData() {
                return _ref.apply(this, arguments);
            };
        }();
        function getAssetProgress(transCodeId) {
            return _getAssetProgress.apply(this, arguments);
        }
        function _getAssetProgress() {
            _getAssetProgress = // 转码
            // eslint-disable-next-line consistent-return
            _asyncToGenerator(regeneratorRuntime.mark(function _callee(transCodeId) {
                var _$ref, data, update;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return getTranscodeProgress(transCodeId);
                        case 2:
                            _$ref = _ctx.sent;
                            data = _$ref.data;
                            update = _$ref.update;
                            if (!update) {
                                _ctx.next = 8;
                                break;
                            }
                            initListData();
                            return _ctx.abrupt("return");
                        case 8:
                            listData.value = updateProgress(listData.value, data);
                            timer = setTimeout(function() {
                                getAssetProgress(transCodeId);
                            }, 3000);
                        case 10:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _getAssetProgress.apply(this, arguments);
        }
        var initTagAssetData = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var _$ref, tool, type, res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            tool = getToolKey(model.value.type);
                            type = getTypeKey(model.value.type);
                            listLoading.value = true;
                            _ctx.next = 7;
                            return getMainTagAssetList({
                                type: type,
                                tool: tool,
                                size_max: model.value.size_max,
                                formats: model.value.type === "action" ? undefined : (_$ref = model.value.formats) === null || _$ref === void 0 ? void 0 : _$ref.join(","),
                                skeleton_type: model.value.skeleton_type || undefined
                            }, {
                                // @ts-ignore
                                cancelToken: ""
                            });
                        case 7:
                            res = _ctx.sent;
                            listData.value = _.get(res, "data.list") || [];
                            tagList.value = _.get(res, "data.tags") || [];
                            listLoading.value = false;
                            _ctx.next = 17;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            listLoading.value = false;
                            console.log(_ctx.t0);
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }));
            return function initTagAssetData() {
                return _ref.apply(this, arguments);
            };
        }();
        var initCommonAssetData = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var _$ref, tool, type, listTagIds, tagIds, allTagIds, tag_ids, res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            ;
                            tool = getToolKey(model.value.type);
                            type = getTypeKey(model.value.type);
                            listLoading.value = true;
                            listTagIds = currentTab.listTagId && currentTab.listTagId.split(",") || [];
                            tagIds = currentTab.tagId && currentTab.tagId.split(",") || [];
                            allTagIds = listTagIds === null || listTagIds === void 0 ? void 0 : listTagIds.concat(tagIds);
                            ;
                            // audio/seqframe/model/action查询：group_id+tag_ids；其他资源统一在tag_ids
                            if (defaultTab.value !== tabNameList.commonAudio && defaultTab.value !== tabNameList.commonFrameSequence && defaultTab.value !== tabNameList.commonModel && defaultTab.value !== tabNameList.commonAction) {
                                if (allTagIds.length && currentTab.groupId) {
                                    tag_ids = allTagIds.join(",") + "," + currentTab.groupId;
                                } else if (currentTab.groupId) {
                                    tag_ids = currentTab.groupId;
                                } else {
                                    tag_ids = allTagIds.length ? allTagIds.join(",") : null;
                                }
                            } else {
                                tag_ids = allTagIds.length ? allTagIds.join(",") : null;
                            }
                            _ctx.next = 12;
                            return getCommonComponentList({
                                // @ts-ignore
                                tag_ids: tag_ids,
                                group_id: defaultTab.value === tabNameList.commonAudio || defaultTab.value === tabNameList.commonFrameSequence || defaultTab.value === tabNameList.commonModel || defaultTab.value === tabNameList.commonAction ? currentTab.groupId : null,
                                tool: tool,
                                page_size: 1000,
                                name: currentTab.search,
                                type: type,
                                size_max: model.value.size_max,
                                formats: model.value.type === "action" ? undefined : (_$ref = model.value.formats) === null || _$ref === void 0 ? void 0 : _$ref.join(","),
                                skeleton_type: model.value.skeleton_type || undefined
                            }, {
                                config: ""
                            });
                        case 12:
                            res = _ctx.sent;
                            listData.value = _.get(res, "data.list") || [];
                            tagList.value = _.get(res, "data.tags") || [];
                            listLoading.value = false;
                            _ctx.next = 22;
                            break;
                        case 18:
                            _ctx.prev = 18;
                            _ctx.t0 = _ctx["catch"](0);
                            listLoading.value = false;
                            console.log(_ctx.t0);
                        case 22:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        18
                    ]
                ]);
            }));
            return function initCommonAssetData() {
                return _ref.apply(this, arguments);
            };
        }();
        var initGetAssistTag = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
                var tool, type, res;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            tool = getToolKey(model.value.type);
                            type = getTypeKey(model.value.type);
                            _ctx.next = 5;
                            return getAssetTag({
                                type: type,
                                // @ts-ignore
                                tool: tool,
                                skeleton_type: model.value.skeleton_type || undefined
                            }, {});
                        case 5:
                            res = _ctx.sent;
                            // @ts-ignore
                            if (res.code === 0) {
                                searchOptions.value = _.get(res, "data.list") || [];
                                searchOptions.value.forEach(function(item) {
                                    item.option = item.sub_tags;
                                    delete item.sub_tags;
                                });
                            }
                            _ctx.next = 12;
                            break;
                        case 9:
                            _ctx.prev = 9;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        9
                    ]
                ]);
            }));
            return function initGetAssistTag() {
                return _ref.apply(this, arguments);
            };
        }();
        var handleTabClick = function(key) {
            clearCurretTab();
            currentTab.key = key;
            listData.value = [];
            tagList.value = [];
            if (currentTab.key.indexOf("asset") !== -1) {
                initListData();
            } else if (currentTab.key.indexOf("common") !== -1) {
                initTagAssetData();
                if (!searchOptions.value.length) {
                    initGetAssistTag();
                }
            }
        };
        var handleAddResource = function(res) {
            if (currentTab.key.indexOf("asset") !== -1) {
                if (model.value.type === "model") {
                    emit("addResource", {
                        file: res,
                        type: "asset"
                    });
                } else {
                    emit("addResource", res);
                }
            } else {
                emit("addResource", {
                    file: res,
                    type: "common"
                });
            }
        };
        var getCommonHotComponents = function() {
            clearCurretTab();
            searchFilterRef.value && searchFilterRef.value.handleClearAll();
            initTagAssetData();
        };
        var getCommonComponentsByTag = function(param) {
            var id = param.id, type = param.type;
            currentTab.listTagId = id;
            initCommonAssetData();
        };
        var viewTagAllData = function(tagInfo) {
            listData.value = [];
            currentTab.groupId = tagInfo.id;
            currentTab.componentsTitle = tagInfo.name;
            currentTab.type = tagInfo.type;
            initCommonAssetData();
        };
        var handleSearch = function(val) {
            if (val !== undefined) {
                currentTab.search = val;
            }
            listData.value = [];
            tagList.value = [];
            if (currentTab.tagId || currentTab.search || currentTab.listTagId || currentTab.groupId) {
                initCommonAssetData();
            } else {
                initTagAssetData();
            }
        };
        var handleApply = function(tag) {
            currentTab.tagId = tag.value.join(",");
            handleSearch();
        };
        // 转码失败重试
        var retryEvent = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(id) {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return getAssetRetryTranscode(id);
                        case 3:
                            initListData();
                            _ctx.next = 9;
                            break;
                        case 6:
                            _ctx.prev = 6;
                            _ctx.t0 = _ctx["catch"](0);
                            console.log(_ctx.t0);
                        case 9:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        6
                    ]
                ]);
            }));
            return function retryEvent(id) {
                return _ref.apply(this, arguments);
            };
        }();
        watch(function() {
            return visible.value;
        }, function(val) {
            if (val) {
                handleTabClick(defaultTab.value);
                // @ts-ignore
                var dialogStyle = document.getElementsByClassName("resource-manager-dialog")[0].getElementsByClassName("el-dialog")[0];
                // @ts-ignore
                dialogStyle.style.left = "".concat(left.value);
                // @ts-ignore
                dialogStyle.style.top = "".concat(top.value);
            }
        }, {
            immediate: true
        });
        /** 文件上传成功刷新‘我的资产库’数据 */ var refreshAssetData = function() {
            initListData();
        };
        /** 手动刷新页面 */ var initRefresh = function() {
            searchOptions.value = [];
            handleTabClick(defaultTab.value);
        };
        var isAssetTab = function(key) {
            return [
                tabNameList.assetAudio,
                tabNameList.assetImage,
                tabNameList.assetVideo, 
            ].indexOf(key) !== -1;
        };
        onUnmounted(function() {
            timer && clearTimeout(timer);
        });
        return {
            searchFilterRef: searchFilterRef,
            listTotal: listTotal,
            tabList: tabList,
            tagList: tagList,
            currentTab: currentTab,
            listData: listData,
            searchOptions: searchOptions,
            tabNameList: tabNameList,
            listLoading: listLoading,
            retryEvent: retryEvent,
            handleClose: handleClose,
            handleTabClick: handleTabClick,
            handleAddResource: handleAddResource,
            handleApply: handleApply,
            handleSearch: handleSearch,
            viewTagAllData: viewTagAllData,
            getCommonHotComponents: getCommonHotComponents,
            getCommonComponentsByTag: getCommonComponentsByTag,
            refreshAssetData: refreshAssetData,
            initRefresh: initRefresh,
            isAssetTab: isAssetTab
        };
    }
});
